import { render, staticRenderFns } from "./MessageBadge.vue?vue&type=template&id=29015da4"
import script from "./MessageBadge.vue?vue&type=script&lang=js"
export * from "./MessageBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports